import {useLocale} from '#imports';

export function useExperienceImportHotjarSurvey() {
    const {languageCode} = useLocale();

    function triggerExperienceHotjarSurveyEvent() {
        if (window.hj && languageCode.value === 'fr') {
            window.hj('event', 'profile_experience_import_cancelled');
        }
    }

    return {
        triggerExperienceHotjarSurveyEvent,
    };
}
